let variantSize
let variantProductId
let currentVariant = null
let variantColor
$(document).ready(function(){
    var url = new URL(window.location.href);
    var variantId = url.searchParams.get('variant');
    if (variantId !== null) {
        var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
        for(const variant of variantsInfo){
            if(variant.id == variantId){
                variantProductId = variant.product
                variantSize = variant.options[0]
                variantColor = variant.color
                const productId = variant.product
                mp_show_images(productId)
                mp_update_sizes()
                mp_select_variant()
                $('.labellll').removeClass('round-border round-border-color')
                $('.labellll').removeClass('round-border ')

                $('.labellll').each(function(){
                    if(
                        $(this).attr('secondproduct') == variantProductId &&
                        $(this).attr('val') == variantColor
                    ){
                        $(this).addClass('round-border round-border-color')
                    }
                })
                $('.pills-variant-labels').each(function(){
                    if($(this).attr('val').toUpperCase() == variantSize && !$(this).hasClass('disabled')){
                        $(this).addClass('round-border')
                    }
                    if($(this).attr('val').toUpperCase() == variantSize && $(this).hasClass('disabled')){
                        $('.product-form__submit').attr('disabled','disabled')
                        $('.add_to_cart_quantity').text('Sin stock. Consulta en tienda')
                    }
                })
                changeZoomSliderImages(variantColor)
            }
        }
    }
    else{
      $('label[name="TALLA"]').each(function () {
        const $label = $(this);
        const $input = $label.prev('input');
      
        if (!$input.hasClass('disabled')) {
        //   console.log($label)
          setTimeout(() => {
            $label.trigger('click');
          }, 200);
          return false;
        }
      });
    }
  $('.input-variant').on('click',function(){
        const selectedName = $(this).attr('name')
        const selectedValue = $(this).attr('val')

        if(selectedName == 'TALLA'){
          
            variantSize = selectedValue
            $('.pills-variant-labels').removeClass('round-border')
             setTimeout(() => {
                scrollToProductMedia(true)
            }, 100)
        }
        if(selectedName == 'COLOR'){
            variantProductId = $(this).attr('secondproduct')
            const productId = variantProductId
            mp_show_images(productId)
            $('.labellll').removeClass('round-border round-border-color')
            changeZoomSliderImages(selectedValue)
            setTimeout(() => {
                scrollToProductMedia(false)
            }, 100)
            setTimeout(() => {
                const sublistNode = document.querySelector('.js-media-sublist');
                const sublistSwiper2 = sublistNode && sublistNode.swiper;
                if (sublistSwiper2) {
                    if (typeof sublistSwiper2.update === 'function') {
                        sublistSwiper2.update();
                    }
                    if (sublistSwiper2.slides && sublistSwiper2.slides.length) {
                        sublistSwiper2.slideTo(0, 0);
                    }
                }
                // console.log('Se actualizó')
            }, 300);
        }

        mp_update_sizes()
        $(`.labellll[name="${selectedName}"][val="${selectedValue}"]`).addClass('round-border round-border-color')
        mp_select_variant()
    })
})

function scrollToProductMedia(selector) { 
//   console.log("este es el scroll", window.pageYOffset);

  if (window.pageYOffset === 0) return;

  const targets = [
    document.querySelector('.product__media-wrapper'),
    document.querySelector('.product__media-list-wrapper'),
    document.querySelector('.product__media-list')
  ];

  const target = targets.find((el) => el && el.offsetParent !== null);
  if (!target) return;

  const style = getComputedStyle(document.documentElement);
  const headerHeight = parseInt(style.getPropertyValue('--header-height'), 10) || 0;

  const rect = target.getBoundingClientRect();
  const currentTop = window.pageYOffset;

  const OFFSET = selector ? 200 : 100;

  const targetTop = currentTop + rect.top - headerHeight + OFFSET;

  const inView = rect.top >= headerHeight && rect.bottom <= window.innerHeight;

  if (inView || Math.abs(window.pageYOffset - targetTop) < 100) {
    return;
  }

  window.scrollTo({ 
    top: targetTop > 0 ? targetTop : 0, 
    behavior: 'smooth' 
  });
}

function changeZoomSliderImages(color){
    // console.log('bloquea las imagenes')
    $('.s3 [data-color]').each(function() {
        if ($(this).attr('data-color') != color) {
            $(this).css('display', 'none');
        } else {
            $(this).css('display', 'flex');
        }
    });
}

function mp_show_images(productId){
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element]:not([data-element='" + productId + "'])"), (e) => {
        e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
    }),
    Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-element='" + productId + "']"), (e) => {
        e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
    });
}
function mp_select_variant(){
  if(variantSize == undefined){
    $('label[name="TALLA"]').click()
  }
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    for(const variant of variantsInfo){
        if(variant.options.includes(variantSize) && variant.product == variantProductId){

          

        if(variant.inventory_quantity < 4){
					  $('.pocas_piezas_value-plp').removeClass('d-none')
				}else{
					  $('.pocas_piezas_value-plp').addClass('d-none')

				}
            if(variant.available){
                currentVariant = variant.id
                variantColor = variant.color
                $('.outOfStock_Badge').addClass('d-none')
            }
            else{
              $('.outOfStock_Badge').removeClass('d-none')
            }   
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.href);
            $('.product__sku').html('<span class="visually-hidden">SKU:</span>'+variant.sku+'</p>')
            var price = variant.price
             let hasDiscount = variant.has_discount
            // console.log(variant)

            // atoms FRONT-WISHLIST-SHOPIFY-01

            if(window.wishlist_parse != null){
                const wish_product_id = variant.product;
                const wish_product_handle = variant.product_handle;

                console.log(wish_product_id);
                console.log(wish_product_handle);

                const button_wishlist = document.querySelector('.c-button-wishlist__product');
                button_wishlist.dataset.wishlist__id = wish_product_id;
                button_wishlist.dataset.wishlist__handle = wish_product_handle;
            
                button_wishlist.dataset.wishlist__active = 'false';
                window.wishlist_parse.items.forEach(item => {
                    if(item.product_id == wish_product_id){
                        button_wishlist.dataset.wishlist__active = 'true';
                    }
                });
            }

            //
          
            // console.log('no compare ',variant.compare_at_price)
            let sizes = []
            for(const variant of variantsInfo){
                if(variant.product == variantProductId){
                    if(variant.available){
                        sizes.push(variant.options[0])
                    }
                }
            }
            if(variant.compare_at_price){
                console.log('compare ',variant.compare_at_price)
                $('.product__info-container .price-item.price-item--regular').text(variant.compare_at_price)
                $('.product__info-container .price-item.price-item--sale').text(variant.price)
                $('.product__info-container .price__sale').css('display','block')
                $('.product__info-container .price__regular').css('display','none')
                $('.product__info-container .product .price').addClass('price--on-sale')
              if(hasDiscount){
                     const badge = `<img loading="lazy" src="https://cdn.shopify.com/s/files/1/0676/3433/1860/files/Logo_Hot_sale.png?v=1779492334" style="width: 100%;" alt="Hot Sale">`
                     $('.product__media-wrapper .discount-season-badge').html(badge)
                     $('.product__media-wrapper .discount-season-badge').css('width','25%')
                   }
              else{
                const price = parseFloat(
                variant.price.replace(/[^0-9.-]+/g, '')
                )
                const compareAtPrice = parseFloat(
                variant.compare_at_price.replace(/[^0-9.-]+/g, '')
                )
                let badge = ''
                if (compareAtPrice > price) {
                const discount = Math.round(
                    ((compareAtPrice - price) / compareAtPrice) * 100
                )
                badge = `
                `
                }
                $('.product__media-wrapper .discount-season-badge').html(badge)
                $('.product__media-wrapper .discount-season-badge').css('width','100px')
                $('.product__media-list .badge--bottom-left').css('display','inline-block')
                $('.product__media-list .badge--bottom-left').text('-'+ (100-parseInt(parseFloat(variant.price.replace('$ ','').replace(',',''))*100/parseFloat(variant.compare_at_price.replace('$ ','').replace(',',''))))+'%')
              }
            }
            else{
                $('.product__media-list .badge--bottom-left').css('display','none')
                $('.price-item.price-item--regular').text(price)
                $('.product .price').removeClass('price--on-sale')
                $('.price__sale').css('display','none')
                $('.price__regular').css('display','flex')
            }
            $('.availability.product-about__outer h2 span').css('font-weight','normal')
            if(sizes.length == 0){
              $('.product__media-list .badge--bottom-left').css('display','inline-block')
              $('.product__media-list .badge--bottom-left').text('AGOTADO')
              $('.availability.product-about__outer h2 span').css('font-weight','bold')
              if(!$('.availability.product-about__outer h2').hasClass('active')){
                $('.availability.product-about__outer h2').click()
              }
            }
        }
    }
}
function mp_update_sizes(){
    var variantsInfo = JSON.parse(document.getElementById('variants_data').textContent);
    let sizes = []
    for(const variant of variantsInfo){
        if(variant.product == variantProductId){
            if(variant.available){
                sizes.push(variant.options[0])
            }
        }
    }
    let available = true
    $('#SingleOptionSelector-0 input').each(function(){
        if(sizes.includes($(this).val())){
            $(this).removeClass('disabled')
        }
        else{
            $(this).addClass('disabled')
            if(variantSize == $(this).attr('val')){
                available = false
            }
        }
    })
    // console.log(available)
//   console.log(sizes)
const quickCheckoutButton = document.querySelector('.product-form__submit_rapido');
    if(!available){
    //   console.log('No está disponible')
        // console.log($('.labellll *[val="'+variantSize+'"]'))
        $('*[val="'+variantSize+'"].pills-variant-labels').removeClass('round-border')
        $('.product-form__submit').attr('disabled','disabled')
        $('.product-form__submit').text('Sin stock. Consulta en tienda')
        currentVariant = null
        quickCheckoutButton.style.display = 'none';
    }
    else{
        $('*[val="'+variantSize+'"].pills-variant-labels').addClass('round-border')
        $('.product-form__submit').removeAttr('disabled')
         $('.product-form__submit').html(`
            Añadir
          <svg width="19" height="19" viewBox="0 0 18 18" style="margin-left: 5px;margin-bottom: 5px;" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_626_324" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
          <rect width="19" height="19" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_626_324)">
          <path d="M4.81857 16.2857C4.48339 16.2857 4.1997 16.169 3.96747 15.9357C3.73525 15.7024 3.61914 15.4173 3.61914 15.0805V7.49085C3.61914 7.15407 3.73525 6.86902 3.96747 6.63569C4.1997 6.40235 4.48339 6.28569 4.81857 6.28569H6.10724V6.11902C6.10724 5.42846 6.35007 4.83913 6.83575 4.35102C7.32154 3.86302 7.90806 3.61902 8.59533 3.61902C9.2826 3.61902 9.86913 3.86302 10.3549 4.35102C10.8406 4.83913 11.0834 5.42846 11.0834 6.11902V6.28569H12.3721C12.7073 6.28569 12.991 6.40235 13.2232 6.63569C13.4554 6.86902 13.5715 7.15407 13.5715 7.49085V15.0805C13.5715 15.4173 13.4554 15.7024 13.2232 15.9357C12.991 16.169 12.7073 16.2857 12.3721 16.2857H4.81857ZM4.81857 15.2857H12.3721C12.4232 15.2857 12.47 15.2643 12.5124 15.2215C12.555 15.1789 12.5763 15.1319 12.5763 15.0805V7.49085C12.5763 7.43952 12.555 7.39252 12.5124 7.34985C12.47 7.30707 12.4232 7.28569 12.3721 7.28569H11.0834V8.78569C11.0834 8.92757 11.0358 9.04635 10.9404 9.14202C10.8452 9.2378 10.727 9.28569 10.5858 9.28569C10.4446 9.28569 10.3264 9.2378 10.2312 9.14202C10.1358 9.04635 10.0882 8.92757 10.0882 8.78569V7.28569H7.10247V8.78569C7.10247 8.92757 7.05481 9.04635 6.95949 9.14202C6.86428 9.2378 6.74607 9.28569 6.60486 9.28569C6.46364 9.28569 6.34543 9.2378 6.25022 9.14202C6.1549 9.04635 6.10724 8.92757 6.10724 8.78569V7.28569H4.81857C4.76748 7.28569 4.7207 7.30707 4.67824 7.34985C4.63567 7.39252 4.61438 7.43952 4.61438 7.49085V15.0805C4.61438 15.1319 4.63567 15.1789 4.67824 15.2215C4.7207 15.2643 4.76748 15.2857 4.81857 15.2857ZM7.10247 6.28569H10.0882V6.11902C10.0882 5.70113 9.94338 5.34663 9.65377 5.05552C9.36415 4.76452 9.01134 4.61902 8.59533 4.61902C8.17932 4.61902 7.82651 4.76452 7.5369 5.05552C7.24728 5.34663 7.10247 5.70113 7.10247 6.11902V6.28569Z" fill="white"/>
          </g>
          </svg>
          `);
          quickCheckoutButton.style.display = 'block';
    }
}

function mp_add_to_cart(){
    const color = variantColor
    const size = variantSize
    const product = currentVariant

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const cart = document.querySelector("cart-drawer")
    const formData = new FormData();
    formData.append('TALLA', size);
    formData.append('COLOR', color);
    formData.append('form_type', 'product'); 
    formData.append('id', product);
    //formData.append('properties', JSON.stringify({"color":color}));
    formData.append('quantity', $('.quantity__input').val());
    if (cart) {
        formData.append(
            "sections",
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        ncaddToken()
        uploadCart() 
        console.log(this)
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButton.querySelector("span").classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
        } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
        }

        if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
            });
        this.error = false;
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        cart.renderContents(response);
                    });
                },
                { once: true }
            );
            quickAddModal.hide(true);
        } else {
            cart.renderContents(response);
        }
    })
    .catch((e) => {
        console.error(e);
    })
}